class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    this.upsellATC = this.querySelectorAll('[btn-upsell-atc]');
    this.crosssellSlider = this.querySelector('[data-upsell-cart-slider] slider-component')
    let _this = this;
    this.upsellATC.forEach(function(btn){
      btn.addEventListener('click',function(evt){
        _this.addUpselltoCart(evt);
      })
    })

    if(document.querySelector('.drawer.is-empty') == null){
      // this.initCartDiscounts();
      
      // // setup discounts on load
      // let codeSetup = setInterval(function(){
      //   // console.log('iunertvall');
      //   if(document.querySelectorAll('.sc_simple-info__tag .sc-tag').length > 0){
      //     clearInterval(codeSetup);
      //     _this.setupCodes();
      //   }
      // },50)
      
      setTimeout(() => { // remove free products on load
       if(document.querySelector('[data-only-free-product]') != null){ // remove alone free product from cart
          document.querySelector('[data-only-free-product] cart-remove-button').click();
        }
        if(document.querySelectorAll('[data-remove-custom-plan]').length){ // remove free product from cart if subscription is removed
          document.querySelectorAll('[data-remove-custom-plan]').forEach(function(ele){
            ele.querySelector('cart-remove-button').click();
          })
        }
      },200);

      if(this.crosssellSlider != null){
        let activeIndex = this.crosssellSlider.swiper.activeIndex;
        this.crosssellSlider.swiper.on('slideChange', function() {
          // console.log(this.activeIndex, this.realIndex + 1); 
          if(this.activeIndex > activeIndex){
            // console.log('next',_this.crosssellSlider.closest('[data-upsell-cart-slider]').querySelector('[data-upsell-pagination=".swiper-button-next"]'));
            _this.CrosssellPagination(_this.crosssellSlider.closest('[data-upsell-cart-slider]').querySelector('[data-upsell-pagination=".swiper-button-next"]'));
          } else{
            // console.log('prev',_this.crosssellSlider.closest('[data-upsell-cart-slider]').querySelector('[data-upsell-pagination=".swiper-button-prev"]'));
            _this.CrosssellPagination(_this.crosssellSlider.closest('[data-upsell-cart-slider]').querySelector('[data-upsell-pagination=".swiper-button-prev"]'));
          }
          activeIndex = this.activeIndex;
        });
      }
    }
    
  }

  CrosssellPagination(nav){ // crossell section pagination
    document.querySelectorAll('[data-upsell-pagination]').forEach((ele) => ele.classList.remove('disabled')); // remove disabled from all and add to applicable ones
    let btn = nav.dataset.upsellPagination;
    nav.closest('[data-upsell-cart-slider]').querySelector(btn).click();
    if(nav.closest('[data-upsell-cart-slider]').querySelector(btn).getAttribute('aria-disabled') == 'true'){
      nav.classList.add('disabled');
    } else{
      nav.classList.remove('disabled');
    }
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  async open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');

    
      await this.checkByobBundlesInCart();

    // setTimeout(function () {
    //       document.querySelector(".cartDisable").removeAttribute("disabled");
    //     }, 3000); // Enable button after 2 seconds
      
  }

  checkByobBundlesInCart() {
    fetch('/cart.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then(response => response.json())
      .then(cart => {
        // Check if any BYOB bundle exists
        const hasByobBundle = cart.items.some(item => item.properties && item.properties._byob_products);
        console.log("hasByobBundlehasByobBundlehasByobBundle====",hasByobBundle);
        
        // Update the `order_type` attribute
        const attributes = hasByobBundle
          ? { order_type: 'byob' }
          : { order_type: '' };
          console.log("attributesattributesattributes===",attributes);
          
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ attributes }),
        });
      })
      .then(response => response.json())
      .then(data => {
        console.log('Cart updated after product removal:', data);
      })
      .catch(error => {
        console.error('Error handling product removal:', error);
      }).finally(() => {
        // setTimeout(() => {
          const button = document.querySelector(".cartDisable");
          if (button) button.removeAttribute("disabled");
          console.log("finally logic");
        // }, 1000);
      });

      console.log("end");
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  onCartUpdate() {
    console.log('hello cart u[date');
    fetch(`${routes.cart_url}`)
      .then((response) => response.text())
      .then((response) => {
        // console.log('responsee',response);
        const html = new DOMParser().parseFromString(response, 'text/html');
        const sourceQty = html.querySelector('#CartDrawer-Form');
        const AOVBar = html.querySelector('.aov-bar-section');
        // console.log('sourceQty',sourceQty);
        if(AOVBar != null) this.querySelector('.aov-bar-section').innerHTML = AOVBar.innerHTML;
        if(this.querySelector('#CartDrawer-Form') != null) this.querySelector('#CartDrawer-Form').innerHTML = sourceQty.innerHTML;
        if(this.querySelector('#cart-order-summary') != null) this.querySelector('#cart-order-summary').innerHTML = html.querySelector('#cart-order-summary').innerHTML;
        if(this.querySelector('#cart-drawer__footer') != null) this.querySelector('#cart-drawer__footer').innerHTML = html.querySelector('#cart-drawer__footer').innerHTML;
      })
      .catch((e) => {
        console.error(e);
      });
  }

  addTocartForm(form,cart,submitButton,RandomNumber){
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData(form);

    if (cart) {
      formData.append(
        'sections',
        cart.getSectionsToRender().map((section) => section.id)
      );
      formData.append('sections_url', window.location.pathname);
      if(RandomNumber != 0){
        formData.append('properties[_bundle_number]',RandomNumber);
      }
     
      cart.setActiveElement(document.activeElement);
    }
    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'product-form',
            productVariantId: formData.get('id'),
            errors: response.errors || response.description,
            message: response.message,
          });
          if(submitButton != null){
            submitButton.setAttribute('aria-disabled', true);
            submitButton.querySelector('span').classList.add('hidden');
          }
          
          this.error = true;
          return;
        } else if (!cart) {
          window.location = window.routes.cart_url;
          return;
        }

        if (!this.error)
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id') });
          this.error = false;
          cart.renderContents(response);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        if(submitButton != null) submitButton.classList.remove('loading');
        if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        if (!this.error && submitButton != null) submitButton.removeAttribute('aria-disabled');
        if(submitButton != null) submitButton.querySelector('.loading-overlay__spinner').classList.add('hidden');
      });
  }

  addAddonItem(addonBox,RandomNumber){

    let cart  = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    let submitButton = addonBox.closest('[data-atc-container]').querySelector('button[name="add"]');

    // console.log('addonBox',addonBox);

    const upsellForm = document.createElement("form");
    const idInput = document.createElement("input");
    idInput.name = 'id';
    idInput.value = addonBox.querySelector('input').value;
    const qtyInput = document.createElement("input");
    qtyInput.name = 'quantity';
    qtyInput.value = 1;
    upsellForm.appendChild(idInput);
    upsellForm.appendChild(qtyInput);

    this.addTocartForm(upsellForm,cart,submitButton,RandomNumber)
  }

  renderContents(parsedState) {
    var _this = this;
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });
    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      // open cart
      this.open();
    });

    // render discounts
      // setTimeout(() => {
      //   if(document.querySelector('.drawer.is-empty') == null){
      //   this.initCartDiscounts();
      //   }
      // },2000)

      setTimeout(() =>{
        if(document.querySelector('.drawer.is-empty') == null){
          let upsellATC = document.querySelector('cart-drawer').querySelectorAll('[btn-upsell-atc]')
          upsellATC.forEach(function(btn){
            // console.log('btnnn',btn);
            btn.addEventListener('click',function(evt){
              // console.log('btnnn',btn);
              document.querySelector('cart-drawer').addUpselltoCart(evt);
            })
          },50)
        }
      })
    
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    // console.log('selectorrr',selector,new DOMParser().parseFromString(html, 'text/html'));
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        section: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
  
  addUpselltoCart(evt){
    evt.preventDefault();
    var _this = this;

    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');


    this.submitButton = evt.currentTarget;
    // console.log('this.submitButton',this.submitButton);
    this.upsellType = this.submitButton.dataset.upsellType;
    this.qtyInput = evt.target.closest('[data-upsell-container]').querySelector('input[name="quantity"]');
    this.idInput = evt.target.closest('[data-upsell-container]').querySelector('input[name="id"]');
    this.sellingPlanInp = evt.target.closest('[data-upsell-container]').querySelector('input[name="selling_plan"]');
    this.lineInp = evt.target.closest('[data-upsell-container]').querySelector('input[name="line"]');
    this.propInp = evt.target.closest('[data-upsell-container]').querySelectorAll('input[name^="properties"]');
    
    this.submitButton.setAttribute('aria-disabled', true);
    this.submitButton.classList.add('loading');
    this.submitButton.querySelector('.loading-overlay__spinner').classList.remove('hidden');

    // const formData = new FormData(this.form);
    // const inputs = document.getElementsByTagName('input');

    const upsellForm = document.createElement("form");

    
    const qtyInput = document.createElement("input");
    qtyInput.name = 'quantity';
    qtyInput.value = this.qtyInput.value;
    if(this.upsellType == 'subscription upsell'){
      // nothing
    } else if(this.upsellType == 'subscription crosssell'){
      const sellingPLanInp = document.createElement("input");
      sellingPLanInp.name = 'selling_plan';
      sellingPLanInp.value = this.sellingPlanInp.value;
      upsellForm.appendChild(sellingPLanInp);
      const idInput = document.createElement("input");
      idInput.name = 'id';
      idInput.value = this.idInput.value;
      upsellForm.appendChild(idInput);
      // add bundle id for custom diet products
      if(this.propInp.length != 0){
        let propInput;
        this.propInp.forEach(function(inp){
          propInput = document.createElement("input");
          propInput.name = inp.name;
          propInput.value = inp.value;
          upsellForm.appendChild(propInput);
        })
      }
    } else if(this.upsellType == 'replace crosssell'){
      const lineInput = document.createElement("input");
      lineInput.name = 'line';
      lineInput.value = this.lineInp.value;
      upsellForm.appendChild(lineInput);
      const idInput = document.createElement("input");
      idInput.name = 'id';
      idInput.value = this.idInput.value;
      upsellForm.appendChild(idInput);
      if(this.propInp.length != 0){
        let propInput;
        this.propInp.forEach(function(inp){
          propInput = document.createElement("input");
          propInput.name = inp.name;
          propInput.value = inp.value;
          upsellForm.appendChild(propInput);
        })
      }
    } else{
      const idInput = document.createElement("input");
      idInput.name = 'id';
      idInput.value = this.idInput.value;
      upsellForm.appendChild(idInput);
    }

    upsellForm.appendChild(qtyInput);
    if(this.upsellType == 'subscription upsell'){
      const cartItems = this.cart.querySelector('cart-drawer-items');
      let propObj = { };
      if(this.propInp.length != 0){
        this.propInp.forEach(function(inp){
          propObj[inp.name.split('properties[')[1].split(']')[0]] = inp.value;
        })
      }
      cartItems.updateQuantity(this.lineInp.value,this.qtyInput.value,this.sellingPlanInp.value,document.activeElement.getAttribute('name'),propObj)
    } else if(this.upsellType == 'subscription crosssell' || this.upsellType == 'replace crosssell'){
      this.replaceCartProduct(this.lineInp.value,0,upsellForm,this.cart,this.submitButton);
      
    } else{
      this.addTocartForm(upsellForm,this.cart,this.submitButton,0);
    }
  }
  replaceCartProduct(line,quantity,form,cart,submitButton){
    console.log('jdhfhfhhf');
    // this.enableLoading(line);
    // console.log('sections',this.getSectionsToRender());
    const body = JSON.stringify({
      line,
      quantity,
      sections: cart.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`,  { ...fetchConfig(), ...{ body } } )
      .then((response) => response.json())
      .then((response) => {

        if (response.status) {
          if(submitButton != null){
            submitButton.setAttribute('aria-disabled', true);
            submitButton.querySelector('span').classList.add('hidden');
            this.error = true;
          }
          return;
        } else if (!cart) {
          window.location = window.routes.cart_url;
          return;
        }

        if (!this.error)
          // publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart'});
          this.error = false;
          cart.renderContents(response);
          this.addTocartForm(form,cart,submitButton,0);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        if(submitButton != null) submitButton.classList.remove('loading');
        if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        if (!this.error && submitButton != null) submitButton.removeAttribute('aria-disabled');
        if(submitButton != null) submitButton.querySelector('.loading-overlay__spinner').classList.add('hidden');
      });
  }
}

if(document.querySelector('[data-close-drawer],[data-cart-discount-popup]') != null){
  document.querySelector('[data-close-drawer],[data-cart-discount-popup]').addEventListener('click',function(e){
    e.preventDefault();
    if(!e.target.matches('[data-cart-discount-popup]') && !e.target.matches('[data-close-drawer]')) return;
    if(this.classList.contains('drawer')){
      this.classList.remove('active');
    } else{
      this.closest('.drawer').classList.remove('active');
    }
  })
}


customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
